import { colors } from "@areahub/theme";

/**
 *  Colors determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Landslide/FeatureServer/1&source=sd)
 *  */
const STOPS = [
  -9999,
  colors.blueGray[200],
  0,
  colors.green[300],
  0.1,
  colors.amber[300],
  0.5,
  colors.orange[500],
  1.4,
  colors.red[500],
  2.6,
  colors.red[600],
];

/**
 *  Legend determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Landslide/FeatureServer/1&source=sd)
 */
const getLegendRows = () => {
  return [
    ["> 2.6 – 4.3", 11],
    ["> 1.4 – 2.6", 9],
    ["> 0.5 – 1.4", 7],
    ["> 0.1 – 0.5", 5],
    ["0.01 – 0.1", 3],
    ["Data Unavailable", 1],
  ].map((row) => ({
    icon: "draw-polygon",
    label: row[0] === "Data Unavailable" ? row[0] : row[0] + " events/yr",
    color: STOPS[row[1] as number],
  }));
};

export const landslides = {
  stops: STOPS,
  props: getLegendRows(),
};
